module.exports = ol.easing;